// breakpoints
export var breakpoints = {
    phoneMiniDown: 'only screen and (max-width: 375px)',
    phoneMiniUp: 'only screen and (min-width: 376px)',
    phoneDown: 'only screen and (max-width: 500px)',
    phoneUp: 'only screen and (min-width: 501px)',
    tabletDown: 'only screen and (max-width: 766px)',
    tabletUp: 'only screen and (min-width: 767px)',
    tabletLandscapeDown: 'only screen and (max-width: 900px)',
    tabletLandscapeUp: 'only screen and (min-width: 901px)',
    desktopDown: 'only screen and (max-width: 1200px)',
    desktopUp: 'only screen and (min-width: 1201px)',
    largeDesktopDown: 'only screen and (max-width: 1439px)',
    largeDesktopUp: 'only screen and (min-width: 1440px)',
    bigDesktopUp: 'only screen and (min-width: 1653px)',
    xLargeDesktopUp: 'only screen and (min-width: 1800px)',
    //additional, helps minimize repetetive code
    phoneMiniToPhone: "only screen and (min-width: 376px) and (max-width: 500px)",
    phoneToTablet: "only screen and (min-width: 501px) and (max-width: 766px)",
    phoneToDesktop: "only screen and (min-width: 501px) and (max-width: 1200px)",
    tabletToDesktop: "only screen and (min-width: 767px) and (max-width: 1200px)",
    desktopToLargeDesktop: "only screen and (min-width: 1201px) and (max-width: 1439px)",
    desktopToBigDesktop: "only screen and (min-width: 1201px) and (max-width: 1652px)"
};
// colors
export var colors = {
    white: '#FFF',
    blue: '#2279FF',
    darkBlue: '#006bea',
    grey: '#F7F7F7',
    mediumGrey: '#747474',
    black: '#000',
    blackTransparent: 'rgba(0, 0, 0, 0.9)'
};
